(() => {
  const init = root => {
    root.querySelectorAll('.sss-mega-menu--hover').forEach(menu => {
      if (menu.dataset.sssHoverBound === 'true') return;
      menu.dataset.sssHoverBound = 'true';

      const triggers = menu.querySelectorAll('[data-sss-hover-trigger]');
      const states = menu.querySelectorAll('[data-sss-hover-state]');

      const activate = key => {
        triggers.forEach(trigger => {
          trigger.classList.toggle('is-active', trigger.dataset.sssHoverTrigger === key);
        });
        states.forEach(state => {
          const active = state.dataset.sssHoverState === key;
          state.classList.toggle('is-active', active);
          state.hidden = !active;
        });
      };

      triggers.forEach(trigger => {
        trigger.addEventListener('pointerenter', event => {
          if (event.pointerType === 'mouse') activate(trigger.dataset.sssHoverTrigger);
        });
        trigger.addEventListener('focus', () => activate(trigger.dataset.sssHoverTrigger));
      });
    });
  };

  const improveMarkup = root => {
    root.querySelectorAll('.hero-section .banner-overlay-link[aria-label="overlay link"]').forEach(link => {
      const hero = link.closest('.hero-section');
      const label = hero?.querySelector('.hero-section__button')?.textContent?.trim()
        || hero?.querySelector('.hero-section__heading')?.textContent?.trim()
        || 'View featured content';
      link.setAttribute('aria-label', label);
    });

    root.querySelectorAll('.collection-hero__image-container img').forEach(img => {
      img.loading = 'eager';
      img.fetchPriority = 'high';
    });
  };

  const boot = () => {
    init(document);
    improveMarkup(document);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', event => {
    init(event.target);
    improveMarkup(event.target);
  });
})();
